import { useState, useEffect, ChangeEvent } from "react";
import { message, TablePaginationConfig } from "antd";
import { useNavigate } from "react-router-dom";
import { useGetBranchesQuery } from "../../../hooks/BranchManagement/useGetBranchesQuery";
import { useCreateBranchesMutation } from "../../../hooks/BranchManagement/useCreateBranchesMutation";

interface PayloadType {
  name: string;
  address: string;
  lga: string;
  countryCode: string;
  state: string;
  phoneNumber: string;
  id?: string;
}

export const useBranchesHelper = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [states, setStates] = useState<string[]>([]);
  const [lgas, setLgas] = useState<string[]>([]);
  const [selectedState, setSelectedState] = useState<string>("");
  const [selectedLGA, setSelectedLGA] = useState<string>("");
  const { data, isPending } = useGetBranchesQuery({});
  const { mutateAsync, isPending: isCreatingBranch } =
    useCreateBranchesMutation();
  const navigate = useNavigate();

  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: data?.data?.meta?.limit,
  });

  const handleTableChange = (newPagination: TablePaginationConfig) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current ?? 1,
      pageSize: newPagination.pageSize ?? 10,
    }));
  };

  const [payload, setPayload] = useState<PayloadType>({
    name: "",
    address: "",
    lga: selectedLGA,
    countryCode: "NG",
    state: "",
    phoneNumber: "",
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const fetchLGAs = async (state: string) => {
    if (!state) return;
    try {
      const response = await fetch(
        `https://nga-states-lga.onrender.com/?state=${state}`
      );
      if (!response.ok) throw new Error("Failed to fetch LGAs");
      const data = await response.json();
      setLgas(data);
    } catch (error) {
      console.error(error);
      setLgas([]);
      message.error("Failed to fetch LGAs");
    }
  };

  // const handleStateChange = async (e: ChangeEvent<HTMLSelectElement>) => {
  //   const state = e.target.value;
  //   setSelectedState(state);
  //   setSelectedLGA('');
  //   fetchLGAs(state);
  // };

  const handleStateChange = async (e: ChangeEvent<HTMLSelectElement>) => {
    const state = e.target.value;
    setSelectedState(state);
    setSelectedLGA(""); // Reset LGA when state changes
    setPayload((prev) => ({ ...prev, state }));
    fetchLGAs(state); // Fetch LGAs for the selected state
  };

  // const handleLGAChange = (e: ChangeEvent<HTMLSelectElement>) => {
  //   const selectedLGA = e.target.value;
  //   setSelectedLGA(selectedLGA);
  // };
  const handleLGAChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const lga = e.target.value;
    setSelectedLGA(lga);
    setPayload((prev) => ({ ...prev, lga }));
  };
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(
          "https://nga-states-lga.onrender.com/fetch"
        );
        if (!response.ok) throw new Error("Failed to fetch states");
        const data = await response.json();
        setStates(data);
      } catch (error) {
        console.error(error);
        message.error("Failed to fetch states");
      }
    };
    fetchStates();
  }, []);

  return {
    isModalOpen,
    payload,
    states,
    lgas,
    selectedState,
    selectedLGA,
    pagination,
    data,
    rowSelection,
    isCreatingBranch,
    isPending,
    navigate,
    mutateAsync,
    showModal,
    setPayload,
    handleTableChange,
    handleInputChange,
    handleModalClose,
    handleStateChange,
    handleLGAChange,
  };
};
